<template>

    <div>
        <v-card
                flat
                class="pa-3"
        >
            <v-list-item
                    avatar
            >
                <v-list-item-avatar>
                    <img :src="avatar">
                </v-list-item-avatar>

                <v-list-item-content v-if="rating">
                    <v-list-item-title>

                        <div class="d-inline-flex">
                            <v-rating :value="stars"
                                      background-color="secondary"
                                      color="accent"
                                      dense
                                      size="20"
                                      readonly></v-rating>
                            <span class="comment-stars-count">({{rating.stars}})</span>
                            <span class="ml-1" v-if="rating.service_provider_service && rating.service_provider_service.service">
                             <v-icon size="18">arrow_forward</v-icon> {{rating.service_provider_service.service.name}}
                            </span>
                        </div>

                    </v-list-item-title>
                    <v-list-item-subtitle v-html="title"></v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>

            <v-sheet v-if="rating && rating.comment" class="pa-4 mb-1 text-left">
                <p>{{rating.comment}}</p>
            </v-sheet>

            <div v-if="rating && rating.images && rating.images.length">
                <v-layout wrap pa-2>
                    <v-flex xs12>
                        <kimsa-gallery :images="rating.images"></kimsa-gallery>
                    </v-flex>
                </v-layout>
            </div>

        </v-card>

    </div>

</template>
<script>

    import UserCardCompact from '@/components/users/UserCardCompact'
    import {getFakeAvatar} from '@/utils/Common'
    import KimsaGallery from '@/components/common/KimsaGallery'

    export default{
        props: ['rating'],
        components: {
            UserCardCompact,
            KimsaGallery
        },
        data(){
            return {
                stars: this.rating && this.rating.stars || 0
            }
        },
        computed: {
            avatar(){

                var vm = this
                if(!vm.rating || !vm.rating.author) return null
                return vm.rating.author.avatar || getFakeAvatar(vm.rating.author.gender)

            },
            date(){
                var vm = this
                return vm.$moment(vm.rating.created_at).fromNow()
            },
            title(){
                var vm = this

                if(!vm.rating || !vm.rating.author) return ''

                var name = (vm.rating.author.user_name || `${vm.rating.author.first_name} ${vm.rating.author.last_name[0]}.`)
                var date = `<span class="comment-date-moment"> | ${vm.date}</span>`

                return `<span class="comment-user-name">${name}</span>` + date

            }
        }
    }
</script>
<style scoped>

    .comment-user-name{
        font-size: 1.1em;
    }

    .comment-date-moment {
        color: #a4a4a4;
        font-size: .9em;
    }

    .comment-stars-count {
        color: #A4A4A4;
    }
</style>
